import { Emphasis } from "@lya-protect/lya-protect-form-library/dist/UI";
import { ModalContentProps } from "../modal/Modal";
import { ModalCard } from "../modalCard/ModalCard";
import "./garantieModal.scss";

export function GarantieAssistanceModal({ close }: ModalContentProps) {
  return (
    <ModalCard
      close={close}
      className="garantie-modal"
      headerContent={
        <div className="garantie-modal__header">
          <h1>
            <Emphasis>Détail des garanties assistance ⁽¹⁾</Emphasis>
          </h1>
          <p>
            <b>
              Ces garanties sont assurées et réalisées par Ressources Mutuelles
              Assistance <sup>(2)</sup>
            </b>
          </p>
        </div>
      }
      bodyContent={
        <div className="garantie-modal__body">
          <div className="garantie-modal__item">
            <h2>
              Pour accompagner le membre participant en cas d&apos;accident de
              vie courante :
            </h2>
          </div>
          <div className="garantie-modal__item">
            <p className="garantie-modal__item-label">
              Écoute et accompagnement personnalisés :
            </p>
            <p>
              Informations juridiques (réglementaires et pratiques), conseils et
              informations générales sur l&apos;hygiène de vie, la vaccination,
              la santé au travail (TMS, maladies professionnelles...),
              accompagnement à la parentalité...
            </p>
          </div>
          <div className="garantie-modal__item">
            <p className="garantie-modal__item-label">
              Accompagnement psycho-social :
            </p>
            <p>
              Service d&apos;appels de convivialité, service de conseil social,
              service de soutien psychologique.
            </p>
          </div>
          <div className="garantie-modal__item">
            <p className="garantie-modal__item-label">
              En cas d&apos;immobilisation imprévue au domicile :
            </p>
            <p>Acheminement des médicaments ou accompagnement aux courses.</p>
          </div>
          <div className="garantie-modal__item">
            <p className="garantie-modal__item-label">
              En cas d&apos;immobilisation imprévue de plus de 5 jours ou prévue
              de plus de 10 jours :
            </p>
            <p>
              Aide à domicile ou prestations de bien être et de soutien
              (coiffure à domicile, petit jardinage, portage de repas...), garde
              d&apos;enfants, garde d&apos;animaux, dispositif de
              téléassistance...
            </p>
          </div>
          <div className="garantie-modal__item">
            <p className="garantie-modal__item-label">
              En cas de situation de handicap :
            </p>
            <p>
              Entretien et suivi social du handicap, prise en charge du reste à
              charge du matériel médical, inscription à un réseau
              d&apos;entraides pour l&apos;accès à un soutien entre pairs...
            </p>
          </div>
          <div className="garantie-modal__item">
            <h2>Pour accompagner vos proches en cas de décès :</h2>
          </div>
          <div className="garantie-modal__item">
            <p className="garantie-modal__item-label">
              Accompagnement spécifique en cas de décès :
            </p>
            <p>Organisation des obsèques, accompagnement psycho-social.</p>
          </div>
          <div className="garantie-modal__notice">
            <p>
              <sup>(1)</sup> Se référer à la Notice d&apos;information -{" "}
              <a
                tabIndex={-1}
                target="_blank"
                href="https://lya-public.s3.eu-west-3.amazonaws.com/tutelaire/REGLEMENT_tutelaire.pdf"
                rel="noreferrer"
              >
                Garanties d&apos;assistance du contrat Paxivie
              </a>
            </p>
            <p>
              <sup>(2)</sup> Les garanties d&apos;assistance au contrat Paxivie
              sont assurées et réalisées par Ressources Mutuelles Assistance,
              union d&apos;assistance soumise aux dispositions du Livre II du
              Code de la mutualité, dont le siège social est situé au 46 rue du
              Moulin - CS 92443, 44120 Vertou et immatriculée sous le numéro
              Siren 444 269 682.
            </p>
          </div>
        </div>
      }
    />
  );
}
